import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/about/cookie-preferences/page.tsx");
